<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Branches",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Our branches",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Branches",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      nameError: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "branchName",
          sortable: true,
          label: "NAME",
        },
        {
          key: "email",
          sortable: true,
          label: "EMAIL",
        },
        {
          key: "contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "branchAddress",
          sortable: true,
          label: "ADDRESS",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        }
      ],     

      // Value from user input for adding category
      data: {
        name: "",
        email: "",
        contact: "",
        address: "",
      },
      // edit cat
      editdata: {
        name: "",
        email: "",
        contact: "",
        address: "",
        id: "",
      },
      // delete cat
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("branch", ["GetBranch", "BranchState"]),

    ...mapGetters("auth", ["user_permissions"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.GetBranch ? this.GetBranch.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.GetBranch ? this.GetBranch.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchBranch: "branch/fetchBranch",
      AddBranch: "branch/addBranch",
      EditBranch: "branch/editBranch",
      DeleteBranch: "branch/deleteBranch",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addBranch(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "This field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.AddBranch(this.data);
    },

    resetAddBranch() {
      this.data.name = "";
      this.data.email = "";
      this.data.contact = "";
      this.data.address = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditBranch() {
      this.editdata.name = "";
      this.editdata.email = "";
      this.editdata.contact = "";
      this.editdata.address = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetDeleteBranch() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.branchName;
      this.editdata.email = data.item.email;
      this.editdata.contact = data.item.contact;
      this.editdata.address = data.item.branchAddress;
      this.editdata.id = data.item.Id;
    },
    Edit_Branch(modalId) {
      this.modal_id = modalId;
      if (this.editdata.name === "") {
        this.nameError = "This field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.EditBranch(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.branchName;
      this.deletedata.symbol = data.item.symbol;
      this.deletedata.id = data.item.Id;
    },
    delete_Branch(modalId) {
      this.modal_id = modalId;
      this.DeleteBranch(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchBranch();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button
                    class="float-end"
                    variant="primary"
                    v-b-modal.add_branch-modal
                    ><i class="fa fa-plus"></i> New Branch</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add_branch-modal" hide-footer @hidden="resetAddBranch">
                    <template #modal-title> Add new branch</template>
                    <div class="form-group mb-3">
                      <label>Branch name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch name"
                          class="form-control"
                          @input="resetError"
                          v-model="data.name"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Branch email</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch email"
                          class="form-control"
                          @input="resetError"
                          v-model="data.email"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Branch  contact</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch contact"
                          class="form-control"
                          @input="resetError"
                          v-model="data.contact"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Address</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch address"
                          class="form-control"
                          @input="resetError"
                          v-model="data.address"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger pull-left"
                        data-dismiss="modal"
                        @click="closeModal('add_branch-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addBranch('add_branch-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                          v-if="BranchState"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="GetBranch ? GetBranch : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="primary"
                    v-b-modal.edit-branch-modal
                    class="m-2"
                    @click="showEditModal(data)"
                    ><i class="fa fa-edit"></i> Edit</b-button
                  >
                  <b-button
                    size="sm"
                    variant="danger"
                    v-b-modal.delete-branch-modal
                    @click="showDeleteModal(data)"
                    ><i class="fa fa-trash"></i> Delete</b-button
                  >
                </template>
              </b-table>
              <center>
                <h3 v-if="!GetBranch" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </center>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- edit modal starts -->
            <b-modal id="edit-branch-modal" hide-footer @hidden="resetEditBranch">
              <template #modal-title> Edit details for {{ editdata.name }} branch</template>
                  <div class="form-group mb-3">
                      <label>Branch name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch name"
                          class="form-control"
                          @input="resetError"
                          v-model="editdata.name"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Branch email</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch email"
                          class="form-control"
                          @input="resetError"
                          v-model="editdata.email"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Branch  contact</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch contact"
                          class="form-control"
                          @input="resetError"
                          v-model="editdata.contact"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group mb-3">
                      <label>Address</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter branch address"
                          class="form-control"
                          @input="resetError"
                          v-model="editdata.address"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="closeModal('edit-branch-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-primary"
                  @click="Edit_Branch('edit-branch-modal')"
                >
                  <i class="fa fa-check"></i>
                  Save Changes
                  <b-spinner
                    v-if="BranchState"
                    variant="light"
                    small
                    label="Saving"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->

            <!-- modal delete category starts -->
            <b-modal id="delete-branch-modal" hide-footer @hidden="resetDeleteBranch">
              <template #modal-title>
                <h4 class="text-danger">
                  Delete branch {{ deletedata.name }}
                </h4></template
              >
              <div class="form-group mb-3">
                <div class="input-group">
                  <h5>
                    Do you want to delete this branch? Click Proceed Button to delete.
                  </h5>
                </div>
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click="closeModal('delete-branch-modal')"
                >
                  <i class="fa fa-times"></i> Close
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click="delete_Branch('delete-branch-modal')"
                >
                  <i class="fa fa-trash"></i> Proceed
                  <b-spinner
                    v-if="BranchState"
                    variant="light"
                    small
                    label="Deleting"
                  ></b-spinner>
                </button>
              </div>
            </b-modal>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
